import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export default function CampDialog({ open, onOpenChange, form, setForm, onSave }) {
  const upd = (key, value) => setForm({ ...form, [key]: value });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="camp-dialog">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: "Outfit" }}>New camp / event</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2 space-y-1.5">
            <Label>Title *</Label>
            <Input data-testid="camp-title" value={form.title} onChange={(e) => upd("title", e.target.value)} className="min-h-[44px]" placeholder="e.g. Easter Camp — Larch Hill" />
          </div>
          <div className="col-span-2 space-y-1.5">
            <Label>Location</Label>
            <Input data-testid="camp-location" value={form.location} onChange={(e) => upd("location", e.target.value)} className="min-h-[44px]" />
          </div>
          <div className="space-y-1.5">
            <Label>Start date</Label>
            <Input type="date" data-testid="camp-start" value={form.start_date} onChange={(e) => upd("start_date", e.target.value)} className="min-h-[44px]" />
          </div>
          <div className="space-y-1.5">
            <Label>End date</Label>
            <Input type="date" data-testid="camp-end" value={form.end_date} onChange={(e) => upd("end_date", e.target.value)} className="min-h-[44px]" />
          </div>
          <div className="space-y-1.5">
            <Label>Camp fee (€)</Label>
            <Input type="number" step="0.01" data-testid="camp-fee" value={form.fee} onChange={(e) => upd("fee", e.target.value)} className="min-h-[44px]" />
          </div>
          <div className="col-span-2 space-y-1.5">
            <Label>Notes</Label>
            <Textarea data-testid="camp-notes" value={form.notes} onChange={(e) => upd("notes", e.target.value)} rows={2} />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="camp-cancel">Cancel</Button>
          <Button onClick={onSave} data-testid="camp-save" disabled={!form.title.trim()}>Create camp</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
